import React from 'react';

interface BlogPostingSchemaProps {
  title: string;
  description: string;
  image: string;
  url: string;
  publishedDate: string;
  modifiedDate: string;
  authorName?: string;
  keywords?: string;
  articleSection?: string;
}

const BlogPostingSchema: React.FC<BlogPostingSchemaProps> = ({
  title,
  description,
  image,
  url,
  publishedDate,
  modifiedDate,
  authorName = "Women and the Way",
  keywords = "women's health, fertility, acupuncture, Sunshine Coast, Chinese medicine",
  articleSection = "Women's Health & Wellness"
}) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "image": image,
    "url": url,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    },
    "author": {
      "@type": "Organization",
      "name": authorName,
      "url": "https://womenandtheway.com.au"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Women and the Way",
      "logo": {
        "@type": "ImageObject",
        "url": "https://womenandtheway.com.au/watw_logo.jpg"
      },
      "url": "https://womenandtheway.com.au"
    },
    "datePublished": publishedDate,
    "dateModified": modifiedDate,
    "keywords": keywords,
    "articleSection": articleSection,
    "inLanguage": "en-AU",
    "isAccessibleForFree": true,
    "wordCount": "1500-2000"
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default BlogPostingSchema; 